import styled, { keyframes } from 'styled-components';

import { device } from 'styles/breakpoints';

interface SubmitButtonProps {
  isLoading: boolean;
}

export const ValuationFormWrapper = styled.div`
  width: 100%;
  height: 100%;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  padding: 30px;

  & > p {
    font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
    font-size: 1rem;
  }

  input {
    font-weight: ${({ theme }) => theme.typography.fontWeights.light};
    width: 100%;
    max-width: 840px;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 0.5rem 0.625rem 0.5625rem;
    height: 43px;
    font-size: 15px;
    border: 1px solid ${({ theme }) => theme.colors.grayPallet12};
  }

  @media ${device.laptop} {
    & > p {
      font-size: 1rem;
    }
  }

  @media ${device.smallLaptop} {
    input,
    button {
      font-size: 16px !important;
    }
  }

  @media ${device.tablet} {
    padding: 20px 30px 40px !important;

    & > p {
      text-align: center;
    }
  }
`;

export const ValuationFormWrapperMobile = styled.div`
  display: none;

  .autocomplete-input {
    margin: 0 !important;
  }

  .autocomplete-text-field-error {
    display: none;
  }

  .autocomplete-dropdown {
    color: black;
  }

  @media ${device.tablet} {
    display: block;
  }
`;

export const AddressInputWrapper = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`;

export const AddressInputWrapperMobile = styled.div`
  padding: 40px 20px 60px;

  input {
    font-size: 16px !important;
    font-family: ${({ theme }) =>
      theme.typography.fontFamily.walsheimProRegular} !important;
    font-weight: 400 !important;
    border: 1px solid ${({ theme }) => theme.colors.grayPallet23} !important;
    padding: 15px 18px !important;

    &::placeholder {
      color: ${({ theme }) => theme.colors.grayPallet24} !important;
      opacity: 1;
    }
  }
`;

export const FormHeader = styled.p`
  font-family: ${({ theme }) => theme.typography.fontFamily.Inter};
  font-size: 17px;
  font-weight: 500;

  @media ${device.tablet} {
    font-family: ${({ theme }) =>
      theme.typography.fontFamily.walsheimProMedium};
    font-size: 14px !important;
    padding: 0 20px;
    text-align: center;
  }
`;

const SpinKeyframe = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const SubmitButton = styled.button<SubmitButtonProps>`
  background: #00d4a1;
  color: ${({ theme }) => theme.colors.white};
  font-size: 17px;
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: ${({ isLoading }) => (isLoading ? '12.5px' : '20px')};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  .btn-ring:after {
    content: '';
    display: block;
    width: 25px;
    height: 25px;
    margin: 2px;
    border-radius: 50%;
    border: 3px solid ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.white} transparent;
    animation: ${SpinKeyframe} 1.2s linear infinite;

    @media ${device.tablet} {
      width: 20px;
      height: 20px;
    }
  }

  @media ${device.tablet} {
    font-family: ${({ theme }) =>
      theme.typography.fontFamily.walsheimProMedium};
    padding: ${({ isLoading }) => (isLoading ? '12px' : '18px')};
  }
`;

export const NameInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;

  div {
    flex: 1;
    margin-top: 0 !important;
  }
`;

export const HomeValuationForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-top: 20px;

  div {
    margin: 0 !important;
  }

  input {
    font-size: 17px !important;
    font-weight: 400 !important;
    height: 59px !important;
    border: 1px solid ${({ theme }) => theme.colors.grayPallet22} !important;
    padding: 19px 20px !important;
    margin: 0 !important;
  }

  input::placeholder {
    color: ${({ theme }) => theme.colors.grayPallet13};
  }

  @media ${device.tablet} {
    margin-top: 25px;

    input {
      font-family: ${({ theme }) =>
        theme.typography.fontFamily.walsheimProRegular};
      font-size: 16px !important;
      font-weight: 400;
      padding: 15px 18px !important;

      &::placeholder {
        color: ${({ theme }) => theme.colors.grayPallet25};
      }
    }
  }
`;

export const PriceDetailsWrapper = styled.div`
  text-align: center;

  & .value-image {
    margin-bottom: 20px;
    position: relative;
  }

  & .priceWrapper {
    color: ${({ theme }) => theme.colors.greenPallet3};

    h1 {
      margin: 10px;
      font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont,
        'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
        'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
        'Noto Color Emoji';
      font-size: 35px;
    }

    p {
      font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
      text-decoration: underline;
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      margin: 15px 0px 20px;
      color: ${({ theme }) => theme.colors.grayPallet14};
      font-size: 15px;
    }
  }
`;

export const Disclaimer = styled.p`
  color: ${({ theme }) => theme.colors.grayPallet15};
  font-weight: ${({ theme }) => theme.typography.fontWeights.light};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  @media ${device.tablet} {
    display: none;
  }
`;

export const BackCTA = styled.button`
  display: none;
  font-family: ${({ theme }) => theme.typography.fontFamily.walsheimProMedium};
  font-size: 16px;
  color: ${({ theme }) => theme.colors.blackPallet6};
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colors.blackPallet6};
  text-align: center;
  padding: 16px;

  @media ${device.tablet} {
    display: block;
  }
`;

export const SelectedAddress = styled.p`
  display: none;
  font-family: ${({ theme }) => theme.typography.fontFamily.walsheimProRegular};
  font-size: 16px;
  text-align: center;
  color: ${({ theme }) => theme.colors.greenPallet5};
  margin-top: 25px;

  @media ${device.tablet} {
    display: block;
  }
`;
